import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleCable = {
  namespaced: true,

  state: {
    name: 'cable',
    nextSeqCode: null,

    cables: [],
    lines: []
  },

  mutations,
  getters,
  actions
}

export default moduleCable;